import graphql from 'babel-plugin-relay/macro';
import {FormikHelpers} from 'formik';
import React from 'react';
import {useMutation} from 'react-relay/hooks';
import {useHistory} from 'react-router';
import ConnectionHandler from 'relay-connection-handler-plus';
import {showEventNotification} from 'src/utils/notifications';

import Form from '../components/Form';
import {FormValues} from '../types';
import {createPageCreateHydrantManufacturerMutation} from './__generated__/createPageCreateHydrantManufacturerMutation.graphql';

function CreatePage() {
  const history = useHistory();

  const [commit, isInFlight] = useMutation<createPageCreateHydrantManufacturerMutation>(
    createHydrantManufacturerMutation,
  );

  return (
    <Form
      title="Create Hydrant Manufacturer"
      button="Create Hydrant Manufacturer"
      onSubmit={handleSubmit}
      isSubmitting={isInFlight}
    />
  );

  function handleSubmit(input: FormValues, formikHelpers: FormikHelpers<FormValues>) {
    commit({
      variables: {input},
      onCompleted: payload => {
        if (
          payload.createHydrantManufacturer?.errors[0] &&
          payload.createHydrantManufacturer?.errors[0].fields
        ) {
          payload.createHydrantManufacturer?.errors[0].fields.forEach(fieldError => {
            formikHelpers.setFieldError(fieldError.fieldName, fieldError.message);
          });
        }

        const entry = payload.createHydrantManufacturer?.hydrantManufacturer;

        if (entry) {
          showEventNotification('added', 'Manufacturer', entry.name);
          return history.push('/admin/hydrant_manufacturers');
        }
      },
      updater: store => {
        const root = store.getRoot();

        const connectionRecords = ConnectionHandler.getConnections(
          root,
          'HydrantManufacturersList_hydrantManufacturers',
        );

        if (!connectionRecords) {
          return;
        }

        const payload = store.getRootField('createHydrantManufacturer');

        if (!payload) {
          return;
        }

        const newRecord = payload.getLinkedRecord('hydrantManufacturer');

        if (!newRecord) {
          return;
        }

        connectionRecords.forEach(connectionRecord => {
          const newEdge = ConnectionHandler.createEdge(
            store,
            connectionRecord,
            newRecord,
            'hydrantManufacturerEdge',
          );

          ConnectionHandler.insertEdgeAfter(connectionRecord, newEdge);
        });
      },
    });
  }
}

const createHydrantManufacturerMutation = graphql`
  mutation createPageCreateHydrantManufacturerMutation($input: CreateHydrantManufacturerInput!) {
    createHydrantManufacturer(input: $input) {
      hydrantManufacturer {
        id
        createdAt
        name
      }
      errors {
        code
        fields {
          fieldName
          message
        }
      }
    }
  }
`;

export default CreatePage;
